import { com } from '@eidu/form'
import entityApiUrl from '../entity/baseUrl'
import { logMessage } from '../../../util/Logging'
import { requireAuthContext } from '../authorization/GlobalAuthContext'
import SemanticLinkId = com.eidu.sharedlib.entity.analytics.SemanticLinkId

type DeleteSemanticLinkParameters = {
  semanticLinkId: SemanticLinkId
}

const deleteSemanticLink = async ({ semanticLinkId }: DeleteSemanticLinkParameters): Promise<void> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links/${semanticLinkId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
    },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return
      case 404:
        logMessage(`Got status ${response.status} from deleteSemanticLink endpoint`, 'warning')
        throw Error(`Semantic link not found: ${semanticLinkId}`)
      default:
        throw Error(`Unexpected response code ${response.status} from deleteSemanticLink endpoint`)
    }
  })
}

export default deleteSemanticLink
